import { RepertoireData, UserRepertoireProgress } from 'Types/RepertoireTypes';

/** How far back a piece counts as recently played. */
export const RECENTLY_PLAYED_DAYS = 7;

/**
 * The pieces the player last played within the past week, for Home's
 * "Recently Played" row: a piece counts by its first progress row, the same row
 * the cards read.
 */
export const recentlyPlayedPieces = (
  repertoireData: readonly RepertoireData[] | undefined,
  progresses: readonly UserRepertoireProgress[] | undefined,
  now: Date,
): RepertoireData[] => {
  const since = new Date(now);
  since.setDate(since.getDate() - RECENTLY_PLAYED_DAYS);
  return (repertoireData ?? []).filter((piece) => {
    const progress = progresses?.find((row) => row.repertoire?.id === piece?.id);
    return !!progress && new Date(progress.last_played_at) > since;
  });
};
